import { AdminsEnhancer } from './AdminsEnhancer'
import { AdminsUI } from './AdminsUI'

export const Admins = AdminsEnhancer(AdminsUI)
